import { NgModule } from '@angular/core';

import { AboutContainerComponent } from './about.container';

import { SharedModule } from '../../shared/shared.module';
import { IconModule } from 'atlas-icon';

export const COMPONENTS = [
  AboutContainerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    // MercerOSModule,
    SharedModule,
    IconModule
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class AboutModule {
}
